export const m = {
  download: 'Download Music',
  moreLyrics: 'View Full Lyrics'
}
